
import moment from "moment";
export class BatchTransformer {
    static transform(batch) {
        return {
            id: batch.id,
            date: batch.attributes.date ? moment(batch.attributes.date).format("MM/DD/YYYY") : null,
            text: batch.attributes.text,
            status: batch.attributes.status,
        };
    }
}



// WEBPACK FOOTER //
// ./src/helpers/batch/batch.transformer.js